import type { TranslateFn } from '@/utils/bank-account-errors';

// Mesmo mapa usado em components/deposit/DefaultLayout.vue (rótulo da conta
// usada num depósito aprovado) e components/user/account/BankAccounts/
// PayerAccounts.vue (rótulo da conta cadastrada) — extraído aqui pra não
// dessincronizar os dois quando um tipo novo entrar ou uma tradução mudar.
export function getBankAccountTypeLabel(type: string, t: TranslateFn): string {
  const labels: Record<string, string> = {
    CORRENTE: t('bank_account.manual_modal.type_corrente'),
    POUPANCA: t('bank_account.manual_modal.type_poupanca'),
    SALARIO: t('bank_account.manual_modal.type_salario'),
    PAGAMENTO: t('bank_account.manual_modal.type_pagamento'),
  };

  return labels[type] ?? type;
}

// "3176" + "X" → "3176-X". Mesma junção usada em ManualAccountModal.vue (pra
// preencher o form de edição) e agora nos rótulos de exibição — sem isso, o
// DV (incluindo o "X") some da tela mesmo estando salvo no backend.
export function joinDigit(main?: string, digit?: string) {
  if (!main) return '';

  return digit ? `${main}-${digit}` : main;
}
